import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g transform="translate(1)">
      <path fill="#0080D5" d="M18.5,0.9376 C16.334,-0.3124 13.666,-0.3124 11.5,0.9376 L3.5,5.5566 C1.334,6.8066 0,9.1186 0,11.6196 L0,20.8566 C0,23.3576 1.334,25.6676 3.5,26.9186 L11,31.2496 L11,17.9776 C11,15.4766 12.334,13.1666 14.5,11.9156 L26,5.2766 L18.5,0.9376 Z"/>
      <path className="euiIcon__fillNegative" d="M18.5,0.9376 C16.334,-0.3124 13.666,-0.3124 11.5,0.9376 L4,5.2766 L15,11.6266 L26,5.2766 L18.5,0.9376 Z"/>
      <path fill="#FA744E" d="M27.4346,7.7608 L17.4086,13.5498 C18.4156,14.7818 18.9996,16.3348 18.9996,17.9778 L18.9996,31.2488 L26.4996,26.9188 C28.6656,25.6678 29.9996,23.3578 29.9996,20.8568 L29.9996,11.6188 C29.9996,9.9798 29.4176,8.4278 28.4126,7.1968 L27.4346,7.7608 Z"/>
    </g>
  </svg>
);
